import React from 'react';

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://vk.com/light_across_eternal_void" className="home__social-icon" target="_blank" rel="noopener noreferrer">
                <i className="uil uil-vk"></i>
            </a>

            <a href="https://t.me/light_across_eternal_void" className="home__social-icon" target="_blank" rel="noopener noreferrer">
                <i className="uil uil-telegram"></i>
            </a>

            <a href="https://github.com/ArsenyCheplyukov" className="home__social-icon" target="_blank" rel="noopener noreferrer">
                <i className="uil uil-github"></i>
            </a>
 
            <a href="https://gitlab.com/ArsenyCheplyukov" className="home__social-icon" target="_blank" rel="noopener noreferrer">    
                <i className="uil uil-gitlab"></i>
            </a>
        </div>
    )
}

export default Social;
